import { render, staticRenderFns } from "./RequestWorkTypesPickerPackagesWarning.vue?vue&type=template&id=771b19d3&"
import script from "./RequestWorkTypesPickerPackagesWarning.vue?vue&type=script&lang=js&"
export * from "./RequestWorkTypesPickerPackagesWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QTable,QTr,QTh,QTd,QCardActions,QBtn} from 'quasar'
component.options.components = Object.assign({QCard,QTable,QTr,QTh,QTd,QCardActions,QBtn}, component.options.components || {})
